<template>
  <div class="pagoda-tooltip-confirm">
    <el-popover
      :placement="$attrs.top || 'top'"
      :width="$attrs.width || '160'"
      v-bind="$attrs"
      v-model="visiable">
      <div class="pagoda-tooltip-confirm__content">
        <slot name="confirm-content">
          {{content}}
        </slot>
      </div>
      <div class="pagoda-tooltip-confirm__footer">
        <el-button size="mini" type="text" :plain="false" @click="handleCancel">取消</el-button>
        <el-button size="mini" type="primary" :plain="false" @click="handleConfirm">确定</el-button>
      </div>
      <div class="pagoda-tooltip-confirm__reference" slot="reference">
        <slot name="default"></slot>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'TooltipConfirm',
  props: {
    content: String
  },
  data () {
    return {
      visiable: false
    }
  },
  methods: {
    handleCancel () {
      this.visiable = false
      this.$emit('cancel')
    },
    handleConfirm () {
      this.visiable = false
      this.$emit('confirm')
    }
  }
}
</script>